<h1 mat-dialog-title>{{ data.mode === 'update' ? 'Update Follow Up Details' : 'Add Follow Up Details' }}</h1>
<div mat-dialog-content>
  <form [formGroup]="data.followUpForm">
    <mat-form-field appearance="fill" class="full-width mb-3 mx-2">
      <mat-label>Follow Up Date</mat-label>
      <input matInput type="date" formControlName="followUpDate">
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width mb-3 mx-2">
      <mat-label>Next Follow Up Date</mat-label>
      <input matInput type="date" formControlName="nextFollowUpDate">
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width mb-3 mx-2">
      <mat-label>Follow Up Details</mat-label>
      <textarea matInput formControlName="followUpDetails"></textarea>
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width mb-3 mx-2">
      <mat-label>Follow Up Remarks</mat-label>
      <textarea matInput formControlName="followUpRemarks"></textarea>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" (click)="onNoClick()">Cancel</button>
  <button class="btn btn-primary" (click)="onSubmit()">
    {{ data.mode === 'update' ? 'Update Follow Up' : 'Add Follow Up' }}
  </button>
</div>
